import { Tenant } from './types';

// Données mockées pour les tenants
export const mockTenants: Tenant[] = [
  {
    id: 'tenant-default',
    name: 'Mon Organisation',
    slug: 'mon-organisation',
    status: 'active',
    plan: 'free',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    features: {
      advancedThreatDetection: false,
      vulnerabilityScanning: true,
      assetDiscovery: true,
      complianceReporting: false,
      apiAccess: false,
      customIntegrations: false,
    },
  }
];

export default mockTenants;
